(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psl-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('psl-review-slider')) {
    customElements.define('psl-review-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.psl-reviews__grid');
        this.controls = this.querySelector('.psl-reviews__controls');
        if (!this.track || !this.controls) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous = this.querySelector('[data-review-direction="-1"]');
        this.next = this.querySelector('[data-review-direction="1"]');
        this.position = this.querySelector('.psl-reviews__position');
        const update = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.controls.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (button && !button.disabled) this.move(Number(button.dataset.reviewDirection));
        }, options);
        this.track.addEventListener('scroll', update, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(event.key === 'ArrowLeft' ? -1 : 1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.motion() });
          }
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.psl-reviews__card');
          if (card) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
        }, options);
        this.resize = new ResizeObserver(update);
        this.resize.observe(this.track);
        this.controls.hidden = false;
        this.update();
      }
      motion() {
        return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      }
      move(direction) {
        const card = this.track.firstElementChild;
        if (!card) return;
        const style = getComputedStyle(this.track);
        const gap = parseFloat(style.columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const width = this.track.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const visible = Math.max(1, Math.floor((width + gap + 2) / step));
        this.track.scrollBy({ left: direction * step * visible, behavior: this.motion() });
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
        const bounds = this.track.getBoundingClientRect();
        const cards = [...this.track.children];
        const measured = cards.map((card, index) => ({ index, rect: card.getBoundingClientRect() }));
        const visible = measured.filter(({ rect }) => rect.left >= bounds.left - 2 && rect.right <= bounds.right + 2);
        if (visible.length) {
          const first = visible[0].index + 1;
          const last = visible[visible.length - 1].index + 1;
          this.position.textContent = `${first === last ? first : `${first}–${last}`} / ${cards.length}`;
        } else if (measured.length) {
          const nearest = measured.reduce((best, card) => Math.abs(card.rect.left - bounds.left) < Math.abs(best.rect.left - bounds.left) ? card : best);
          this.position.textContent = `${nearest.index + 1} / ${cards.length}`;
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psl-footer"]) return;
  try {
    
  function setupPSLFooter(root) {
    const media = window.matchMedia('(max-width: 749px)');
    root.querySelectorAll('.psl-footer__group').forEach((group) => {
      if (group.dataset.pslReady) return;
      group.dataset.pslReady = 'true';
      group.open = !media.matches;
      media.addEventListener('change', () => { group.open = !media.matches; });
    });
  }
  setupPSLFooter(document);
  document.addEventListener('shopify:section:load', (event) => setupPSLFooter(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psl-home-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-psl-model-details]');
    if (!link) return;
    const comparison = document.getElementById(link.hash.slice(1));
    if (comparison instanceof HTMLDetailsElement) comparison.open = true;
  });

  } catch(e) { console.error(e); }
})();
})();
